import { IResourceComponentsProps } from "@pankod/refine-core";
import {
  Create,
  useForm,
} from "@pankod/refine-antd";
import { IOrigins } from "interfaces";
import { OriginsForm } from "components/forms";

export const OriginsCreate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<IOrigins>();
  return (
    <Create saveButtonProps={saveButtonProps}>
      <OriginsForm
        formProps={formProps}
        queryResult={queryResult}
      />
    </Create>
  );
};
